import { render, staticRenderFns } from "./PageModems.vue?vue&type=template&id=df52adc2&"
import script from "./PageModems.vue?vue&type=script&lang=js&"
export * from "./PageModems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports